export const isValidURL = (value: string): boolean => {
  try {
    const withProtocol = value.match(/^https?:\/\//i) ? value : `https://${value}`;
    const url = new URL(withProtocol);
    return !!url.hostname && url.hostname.includes('.');
  } catch {
    return false;
  }
};
